import { render, staticRenderFns } from "./WeekRowItem.vue?vue&type=template&id=06bb1b4e"
import script from "./WeekRowItem.ts?vue&type=script&lang=ts&external"
export * from "./WeekRowItem.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports